import { render } from "./simpleSearch.vue?vue&type=template&id=67775874"
import script from "./simpleSearch.vue?vue&type=script&lang=js"
export * from "./simpleSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__